import { CommonUtils } from "../../util/common-utils";

export class ChoicesControlRender {
    public static ensureOptionsAndSelect(select: HTMLSelectElement, values: string[]): void {
        const existing = new Set(Array.from(select.options).map((option) => option.value));
        const missingValues = values.filter((value) => !existing.has(value));

        if (missingValues.length > 0) {
            const html = missingValues
                .map((value) => {
                    const escapedValue = CommonUtils.escapeHtmlAttribute(value);
                    const escapedLabel = CommonUtils.escapeHtml(value);
                    return `<option value="${escapedValue}" selected>${escapedLabel}</option>`;
                })
                .join("");

            select.insertAdjacentHTML("beforeend", html);
            missingValues.forEach((value) => {
                existing.add(value);
            });
        }

        values.forEach((value) => {
            const option = Array.from(select.options).find((entry) => entry.value === value);
            if (option) option.selected = true;
        });
    }

    public static renderInputValue(input: HTMLInputElement | null, value: string): void {
        if (input instanceof HTMLInputElement) {
            input.value = value;
        }
    }

    public static renderNativeSelectionCleared(select: HTMLSelectElement): void {
        Array.from(select.options).forEach((option) => {
            option.selected = false;
        });
        select.value = "";
    }

    public static renderChoicesPlaceholder(select: HTMLSelectElement, placeholder: string): void {
        select.dataset.choicesPlaceholder = placeholder;
    }

    public static renderPlaceholderOriginal(input: HTMLInputElement | null, placeholder: string): void {
        if (input instanceof HTMLInputElement) {
            input.dataset.placeholderOriginal = placeholder;
        }
    }

    public static renderInputPlaceholder(input: HTMLInputElement | null, placeholder: string): void {
        if (input instanceof HTMLInputElement) {
            input.setAttribute("placeholder", placeholder);
        }
    }

    public static renderHasItemsState(
        controlRoot: HTMLElement | null,
        choicesRoot: HTMLElement | null,
        hasItems: boolean,
    ): void {
        if (controlRoot instanceof HTMLElement) {
            controlRoot.classList.toggle("has-items", hasItems);
        }

        if (choicesRoot instanceof HTMLElement) {
            choicesRoot.classList.toggle("has-items", hasItems);
        }
    }

    public static moveClearButtonIntoInner(inner: HTMLElement | null, clearButton: HTMLButtonElement): void {
        if (inner instanceof HTMLElement && clearButton.parentElement !== inner) {
            inner.appendChild(clearButton);
        }
    }
}